import { FC } from 'react'

export const initialState: IModal[] | null = null

export type ModalProps = {
  onPrev: (props?: any) => void
  onNext: (props?: any) => void
  closeThisModal: () => void
  /**
   * A step component with its own inner navigation registers a handler here; the
   * modal's header back arrow calls it first and only falls back to onPrev when it
   * returns false. Register null on unmount.
   */
  registerBackHandler?: (handler: (() => boolean) | null) => void
}

export type IModal = {
  id: string
  components: FC<ModalProps>[]
  title?: string
  onClose?: (id: string) => void
  shouldHideCross?: boolean
  startIndex?: number
  /**
   * QRM-641: width of the centred dialog from the web breakpoint up (e.g. '640px').
   * Ignored below it — there the modal is a full-width bottom sheet as before.
   */
  dialogWidth?: string
}
